<template>
    <div
        ref="mybetssection"
        class="mybetssection"
        :style="dynamicHeight"
        :class="{
            'dark-theme': $vuetify.theme.dark,
            'white-theme': !$vuetify.theme.dark
        }"
    >
        <div
            v-if="pageName !== 'bets'"
            class="my-bet-section pt-0 px-0 pb-0"
            :class="{
                'px-2': $breakpoint.smAndDown
            }"
        >
            <v-expansion-panels :value="openAll" flat tile multiple>
                <v-expansion-panel
                    v-for="(betsData, i) in betsDatas"
                    :key="'betdata' + i"
                    class="top-btm-space mybet-card"
                >
                    <v-expansion-panel-header
                        class="pl-0 pt-0 pb-0 caption align-self-stretch"
                    >
                        <v-row no-gutters>
                            <v-col cols="6" class="pl-2 py-2">
                                {{ betsData.name }}
                            </v-col>
                            <v-col cols="6">
                                <div
                                    v-if="
                                        !checkunMatchBets() &&
                                        betsData.name === 'Unmatched Bets'
                                    "
                                    class="d-flex align-end flex-column pr-1 py-1"
                                >
                                    <v-btn
                                        small
                                        color="red darken-3"
                                        tile
                                        dark
                                        depressed
                                        @click.native.stop="
                                            cancelAllBets(betsData)
                                        "
                                        >Cancel All</v-btn
                                    >
                                </div>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content dark class="pa-0">
                        <div v-if="betsData.name === 'Unmatched Bets'">
                            <div
                                v-for="(
                                    unMatchedbets, j
                                ) in betsData.unMatchedbets"
                                :key="'unmatchBets' + j"
                            >
                                <v-list-item-title
                                    class="caption font-weight-bold px-1 pt-2"
                                >
                                    {{ unMatchedbets.matchName }}
                                </v-list-item-title>
                                <div
                                    v-for="(market, u) in unMatchedbets.markets"
                                    :key="'market' + j + u"
                                >
                                    <v-card
                                        v-for="(
                                            betsData1, betIndex
                                        ) in market.runners"
                                        :key="'unmatchBets' + betIndex"
                                        class="pa-0 mb-0 caption mybet-card"
                                    >
                                        <div class="unmatch-section">
                                            <div>
                                                <v-list-item-title
                                                    class="caption font-weight-bold px-2"
                                                >
                                                    <div
                                                        v-if="
                                                            !checkunMatchBets()
                                                        "
                                                        class="d-flex mt-2 pt-1 pr-1"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="6">
                                                                {{
                                                                    market.name
                                                                }}
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-btn
                                                                    v-if="
                                                                        betsData1 &&
                                                                        betsData1.bets &&
                                                                        betsData1
                                                                            .bets[0]
                                                                            .betType !==
                                                                            'threeEt'
                                                                    "
                                                                    x-small
                                                                    color="red darken-3"
                                                                    tile
                                                                    text
                                                                    class="flex-column float-right align-end"
                                                                    @click.native.stop="
                                                                        cancelPerMatch(
                                                                            betsData1
                                                                        )
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </v-list-item-title>
                                                <div>
                                                    <!-- <div
                      v-for="(bets, betsIndex) in betsData1"
                      :key="'bets' + betsIndex"
                    > -->
                                                    <v-list-item-title
                                                        class="caption px-2 pt-1"
                                                    >
                                                        {{ betsData1.name }}
                                                    </v-list-item-title>
                                                    <div
                                                        v-for="(
                                                            bet, betIndex1
                                                        ) in betsData1.bets"
                                                        :key="'bet' + betIndex1"
                                                        :class="{
                                                            secondary:
                                                                bet.type ==
                                                                'BACK',
                                                            accent:
                                                                bet.type ==
                                                                'LAY'
                                                        }"
                                                        class="px-2 pt-3 odds"
                                                    >
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                            class="my-0"
                                                        >
                                                            <v-col
                                                                cols="3"
                                                                class="pb-0 pr-0"
                                                            >
                                                                <v-text-field
                                                                    ref="odds"
                                                                    :value="
                                                                        bet.betType ===
                                                                        'lineLadder'
                                                                            ? ceilMethod(
                                                                                  bet.odds
                                                                              )
                                                                            : bet.betRate
                                                                    "
                                                                    :label="
                                                                        bet.betType ===
                                                                        'lineLadder'
                                                                            ? 'Runs'
                                                                            : 'Odds'
                                                                    "
                                                                    persistent-hint
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    class="caption font-weight-bold text-black"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="pb-0 pr-0"
                                                            >
                                                                <v-text-field
                                                                    ref="stake"
                                                                    :value="
                                                                        bet.stake
                                                                    "
                                                                    label="Stake"
                                                                    persistent-hint
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    class="caption font-weight-bold text-black"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="pt-0 pb-0"
                                                            >
                                                                <div
                                                                    style="
                                                                        font-size: 10px;
                                                                        margin-top: -1.4rem;
                                                                        color: black;
                                                                        transform: translateY(
                                                                                -0.2rem
                                                                            )
                                                                            scale(
                                                                                0.9
                                                                            )
                                                                            translateX(
                                                                                -0.2rem
                                                                            );
                                                                    "
                                                                    class="font-weight-bold"
                                                                >
                                                                    Profit
                                                                </div>
                                                                <div
                                                                    class="font-weight-bold"
                                                                    style="
                                                                        color: black;
                                                                    "
                                                                >
                                                                    {{
                                                                        ((bet.betRate -
                                                                            1) *
                                                                            bet.stake)
                                                                            | currencyFormat(
                                                                                2
                                                                            )
                                                                    }}
                                                                </div>
                                                            </v-col>
                                                            <v-col
                                                                cols="3"
                                                                class="pt-0 pb-0"
                                                            >
                                                                <v-tooltip top>
                                                                    <template
                                                                        #activator="{
                                                                            on
                                                                        }"
                                                                    >
                                                                        <v-btn
                                                                            v-if="
                                                                                bet.betType !==
                                                                                'threeEt'
                                                                            "
                                                                            color="red darken-3"
                                                                            block
                                                                            small
                                                                            dark
                                                                            depressed
                                                                            v-on="
                                                                                on
                                                                            "
                                                                            @click="
                                                                                cancelBet(
                                                                                    bet,
                                                                                    ''
                                                                                )
                                                                            "
                                                                        >
                                                                            <v-icon
                                                                                size="14"
                                                                                >mdi-close</v-icon
                                                                            >
                                                                        </v-btn>
                                                                    </template>
                                                                    <span
                                                                        >Cancel</span
                                                                    >
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                        <v-divider></v-divider>
                                                    </div>
                                                    <!-- </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </v-card>
                                </div>
                            </div>
                            <div
                                v-if="
                                    !betsData.unMatchedbets.length && !loading
                                "
                            >
                                <no-data-found
                                    icon-custom="mdi mdi-alert"
                                    bet-text="No Unmatched Bets!"
                                />
                            </div>
                        </div>

                        <div
                            v-if="betsData.name === 'Matched Bets'"
                            class="matched-bets"
                        >
                            <div class="green--text d-flex">
                                <v-checkbox
                                    v-if="betsData.matchedBets.length"
                                    v-model="showAverage"
                                    label="Average Odds"
                                    hide-details
                                    class="my-0 caption top-0 matched-bets-checkbox"
                                    :class="
                                        $breakpoint.mdAndUp ? 'ml-1' : 'ml-2'
                                    "
                                    dense
                                ></v-checkbox>
                                <v-checkbox
                                    v-if="betsData.matchedBets.length"
                                    v-model="sortBets"
                                    label="Sort By Matched Time"
                                    hide-details
                                    class="my-0 caption top-0 matched-bets-checkbox"
                                    :class="
                                        $breakpoint.mdAndUp ? 'ml-1' : 'ml-2'
                                    "
                                    dense
                                ></v-checkbox>
                            </div>
                            <div v-if="showAverage">
                                <average-bets
                                    :bets="betsData.matchedBets"
                                ></average-bets>
                            </div>
                            <div v-if="!showAverage">
                                <template
                                    v-for="(bet, j) in betsData.matchedBets"
                                >
                                    <ob-card
                                        :key="'ob-card-' + j"
                                        :bets-data="betsData"
                                        :bets-group="bet"
                                        :sort-bets="sortBets"
                                    ></ob-card>
                                    <!-- <v-divider :key="'divider-' + j"></v-divider> -->
                                </template>
                            </div>
                            <div v-if="!betsData.matchedBets.length">
                                <no-data-found
                                    bet-text="No Matched Bets!"
                                    icon-custom="mdi mdi-alert"
                                />
                            </div>
                        </div>
                        <div
                            v-if="betsData.name === 'Line Session'"
                            class="matched-bets"
                        >
                            <div class="green--text d-flex">
                                <v-checkbox
                                    v-if="betsData.lineLadder.length"
                                    v-model="showLadderAverage"
                                    label="Average Odds"
                                    hide-details
                                    class="my-0 caption top-0 matched-bets-checkbox"
                                    :class="
                                        $breakpoint.mdAndUp ? 'ml-1' : 'ml-2'
                                    "
                                    dense
                                ></v-checkbox>
                                <v-checkbox
                                    v-if="betsData.lineLadder.length"
                                    v-model="sortLadderBets"
                                    label="Sort By Matched Time"
                                    hide-details
                                    class="my-0 caption top-0 matched-bets-checkbox"
                                    :class="
                                        $breakpoint.mdAndUp ? 'ml-1' : 'ml-2'
                                    "
                                    dense
                                ></v-checkbox>
                            </div>
                            <div v-if="showLadderAverage">
                                <average-bets
                                    :bets="betsData.lineLadder"
                                ></average-bets>
                            </div>
                            <div v-if="!showLadderAverage">
                                <template
                                    v-for="(bet, j) in betsData.lineLadder"
                                >
                                    <ob-card
                                        :key="'ob-card-' + j"
                                        :bets-data="betsData"
                                        :bets-group="bet"
                                        :sort-bets="sortLadderBets"
                                    ></ob-card>
                                    <!-- <v-divider :key="'divider-' + j"></v-divider> -->
                                </template>
                            </div>
                            <div v-if="!betsData.lineLadder.length">
                                <no-data-found
                                    bet-text="No Line Session Bets!"
                                    icon-custom="mdi mdi-alert"
                                />
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <!-- ****** only for open bet Artemis Bookmaker Market ******-->
            <v-expansion-panels :value="openAllPremium" flat tile multiple>
                <v-expansion-panel
                    v-for="(betsData, i) in betsDatasPremiumBookmaker"
                    :key="'betdata' + i"
                    class="top-btm-space dropdown"
                >
                    <v-expansion-panel-header
                        class="pl-0 pt-0 pb-0 caption align-self-stretch dropdown"
                    >
                        <v-row no-gutters>
                            <v-col cols="12" class="pl-2 py-2">
                                {{ betsData.name }}
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content dark class="pa-0">
                        <div v-if="betsData.name === 'Premium Bookmaker'">
                            <div
                                v-if="
                                    !matchedBetBookmakerMarket &&
                                    !matchedBetBookmakerMarket
                                "
                            >
                                <no-data-found
                                    icon-custom="mdi mdi-alert"
                                    bet-text="No Premium Bookmaker Bets!"
                                />
                            </div>
                            <matched-bets-premium-bookmaker-raw
                                v-if="
                                    matchedBetBookmakerMarket &&
                                    matchedBetBookmakerMarket.length
                                "
                                :bet-data-matched-premium="
                                    matchedBetBookmakerMarket
                                "
                            />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <!-- ****** only for open bet betby ******-->
            <v-expansion-panels :value="openAllPremium" flat tile multiple>
                <v-expansion-panel
                    v-for="(betsData, i) in betsDatasPremium"
                    :key="'betdata' + i"
                    class="top-btm-space dropdown"
                >
                    <v-expansion-panel-header
                        class="pl-0 pt-0 pb-0 caption align-self-stretch dropdown"
                    >
                        <v-row no-gutters>
                            <v-col cols="12" class="pl-2 py-2">
                                {{ betsData.name }}
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content dark class="pa-0">
                        <div v-if="betsData.name === 'Premium SportsBook'">
                            <div
                                v-if="
                                    !matchedBetPremiumData &&
                                    !matchedBetPremiumRawData
                                "
                            >
                                <no-data-found
                                    icon-custom="mdi mdi-alert"
                                    bet-text="No Premium SportsBook Bets!"
                                />
                            </div>
                            <matched-bets-premium
                                v-if="
                                    matchedBetPremiumData &&
                                    matchedBetPremiumData.length
                                "
                                :bet-data-matched-premium="
                                    matchedBetPremiumData
                                "
                            />
                            <matched-bets-premium-raw
                                v-if="matchedBetPremiumRawData"
                                :bet-data-matched-premium="
                                    matchedBetPremiumRawData
                                "
                            />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <!-- ****** only for open bet drawer show this section ******-->
        <div
            v-if="pageName === 'bets'"
            class="bet-market-section"
            :class="{
                'dark-theme': $vuetify.theme.dark,
                'white-theme': !$vuetify.theme.dark
            }"
        >
            <v-tabs v-model="tabs" centered>
                <v-tab class="caption" @click="opendata()"> my bet </v-tab>
                <v-tab
                    v-if="($auth.user && $auth.user.sportsbook) || !$auth.user"
                    class="caption"
                    @click="openMyMarket()"
                >
                    my market
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <!-- my bets section -->
                <v-tab-item>
                    <div class="my-bet-section px-2">
                        <v-expansion-panels :value="openAll" flat tile multiple>
                            <v-expansion-panel
                                v-for="(betsData, i) in betsDatas"
                                :key="'betdatas' + i"
                                class="mt-2"
                            >
                                <v-expansion-panel-header
                                    class="caption bg-dark dropdown"
                                >
                                    {{ betsData.name }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    class="black--text pa-0 border-bottom-lr"
                                >
                                    <div
                                        v-if="
                                            betsData.name === 'Unmatched Bets'
                                        "
                                        class="un_bets"
                                    >
                                        <div class="my-bet-border">
                                            <v-card
                                                v-for="(
                                                    unMatchedbets, j
                                                ) in betsData.unMatchedbets.filter(
                                                    (e) => !e.remove
                                                )"
                                                :key="'unmatchBets' + j"
                                                class="pa-0 caption mybet-card border-bottom-lr"
                                            >
                                                <div class="caption pl-3">
                                                    {{
                                                        unMatchedbets.matchName
                                                    }}
                                                </div>
                                                <div
                                                    v-for="(
                                                        betsDataMarket,
                                                        betIndexs
                                                    ) in unMatchedbets.markets"
                                                    :key="
                                                        'unmatchBets' +
                                                        betIndexs
                                                    "
                                                >
                                                    <div
                                                        class="caption font-weight-bold pl-3"
                                                    >
                                                        {{
                                                            betsDataMarket.name
                                                        }}
                                                    </div>
                                                    <div
                                                        v-for="(
                                                            betsData, betIndex
                                                        ) in betsDataMarket.runners"
                                                        :key="
                                                            'unmatchBets' +
                                                            betIndex
                                                        "
                                                    >
                                                        <div
                                                            v-for="(
                                                                bet, betsIndex
                                                            ) in betsData.bets"
                                                            :key="
                                                                'bet' +
                                                                betsIndex
                                                            "
                                                        >
                                                            <!-- <div class="caption pt-1 px-2">
                        {{ bet.horse }}
                      </div> -->
                                                            <div
                                                                :class="{
                                                                    secondary:
                                                                        bet.type ==
                                                                        'BACK',
                                                                    accent:
                                                                        bet.type ==
                                                                        'LAY'
                                                                }"
                                                                class="pa-2"
                                                            >
                                                                <div
                                                                    class="unmatch-section pa-2"
                                                                >
                                                                    <nuxt-link
                                                                        :to="
                                                                            bet.parentCategory
                                                                                ? `/sportsbook/${bet.eventType}/${bet.parentCategory.parentCategory}/${bet.parentCategory._id}`
                                                                                : ''
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="font-weight-bold"
                                                                        >
                                                                            <span
                                                                                v-if="
                                                                                    bet.betType ===
                                                                                    'fancy'
                                                                                "
                                                                                >{{
                                                                                    bet.type ==
                                                                                    "BACK"
                                                                                        ? "YES"
                                                                                        : "NO"
                                                                                }}</span
                                                                            >
                                                                            <span
                                                                                v-if="
                                                                                    bet.betType !==
                                                                                    'fancy'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    bet.type
                                                                                }}</span
                                                                            >
                                                                            {{
                                                                                bet.horse
                                                                            }}
                                                                            for
                                                                            {{
                                                                                bet.stake
                                                                                    | currencyFormat(
                                                                                        0
                                                                                    )
                                                                            }}
                                                                            @
                                                                            <span
                                                                                v-if="
                                                                                    bet.betType !==
                                                                                        'fancy' &&
                                                                                    bet.betType !==
                                                                                        'lineLadder'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    (bet.betType !==
                                                                                        "matchOdds" &&
                                                                                    bet.placeBetCalcType ===
                                                                                        1
                                                                                        ? (bet.averagePriceMatched -
                                                                                              1) *
                                                                                          100
                                                                                        : bet.betType !==
                                                                                              "matchOdds" &&
                                                                                          bet.placeBetCalcType ===
                                                                                              2
                                                                                        ? bet.averagePriceMatched -
                                                                                          1
                                                                                        : bet.averagePriceMatched)
                                                                                        | currencyFormat(
                                                                                            3
                                                                                        )
                                                                                        | fancyOdds(
                                                                                            bet.marketName,
                                                                                            bet.eventType,
                                                                                            bet.marketId,
                                                                                            bet.placeBetCalcType,
                                                                                            bet.betType
                                                                                        )
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-if="
                                                                                    bet.betType ===
                                                                                    'lineLadder'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    (bet.betType !==
                                                                                        "matchOdds" &&
                                                                                    bet.placeBetCalcType ===
                                                                                        1
                                                                                        ? (bet.averagePriceMatched -
                                                                                              1) *
                                                                                          100
                                                                                        : bet.betType !==
                                                                                              "matchOdds" &&
                                                                                          bet.placeBetCalcType ===
                                                                                              2
                                                                                        ? bet.averagePriceMatched -
                                                                                          1
                                                                                        : bet.averagePriceMatched)
                                                                                        | ceil
                                                                                        | fancyOdds(
                                                                                            bet.marketName,
                                                                                            bet.eventType,
                                                                                            bet.marketId,
                                                                                            bet.placeBetCalcType,
                                                                                            bet.betType
                                                                                        )
                                                                                }}
                                                                            </span>
                                                                            <span
                                                                                v-if="
                                                                                    bet.betType ===
                                                                                    'fancy'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    ((bet.averagePriceMatched -
                                                                                        1) *
                                                                                        100)
                                                                                        | currencyFormat
                                                                                }}
                                                                            </span>

                                                                            {{
                                                                                bet.type ==
                                                                                "BACK"
                                                                                    ? "to win"
                                                                                    : "liability"
                                                                            }}
                                                                            {{
                                                                                ((bet.betRate -
                                                                                    1) *
                                                                                    bet.stake)
                                                                                    | currencyFormat(
                                                                                        2
                                                                                    )
                                                                            }}.
                                                                        </div>

                                                                        <div>
                                                                            <span
                                                                                >{{
                                                                                    bet.event
                                                                                }}</span
                                                                            >
                                                                        </div>
                                                                        <!-- <div>
                                <span>{{ bet.marketName }}</span>
                              </div> -->

                                                                        <div>
                                                                            <span
                                                                                >Placed</span
                                                                            >

                                                                            {{
                                                                                $moment(
                                                                                    bet.placedDate
                                                                                ).format(
                                                                                    "DD/MM/YYYY, h:mm:ss a"
                                                                                )
                                                                            }}
                                                                        </div>
                                                                    </nuxt-link>
                                                                    <div
                                                                        class="my-2"
                                                                    >
                                                                        <v-btn
                                                                            color="primary"
                                                                            tile
                                                                            small
                                                                            dark
                                                                            class="rounded-pill"
                                                                            @click="
                                                                                cancelBet(
                                                                                    bet,
                                                                                    ''
                                                                                )
                                                                            "
                                                                            >Cancel</v-btn
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card>
                                        </div>
                                        <div
                                            v-if="
                                                !betsData.unMatchedbets
                                                    .length && !loading
                                            "
                                        >
                                            <no-data-found
                                                icon-custom="mdi mdi-alert"
                                                bet-text="No Unmatched Bets!"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="betsData.name === 'Matched Bets'"
                                        class="m_bets"
                                    >
                                        <div
                                            v-if="
                                                !betsData.matchedBets.length &&
                                                !loading
                                            "
                                        >
                                            <no-data-found
                                                icon-custom="mdi mdi-alert"
                                                bet-text="No Matched Bets!"
                                            />
                                        </div>
                                        <matched-bets
                                            :bet-data-matched="
                                                betsData.matchedBets
                                            "
                                        />
                                    </div>
                                    <div
                                        v-if="betsData.name === 'Line Session'"
                                        class="m_bets"
                                    >
                                        <div
                                            v-if="
                                                !betsData.lineLadder.length &&
                                                !loading
                                            "
                                        >
                                            <no-data-found
                                                icon-custom="mdi mdi-alert"
                                                bet-text="No Line Session Bets!"
                                            />
                                        </div>
                                        <matched-bets
                                            :bet-data-matched="
                                                betsData.lineLadder
                                            "
                                        />
                                    </div>
                                </v-expansion-panel-content>
                                <!-- <hr class="primary" style="opacity: 0.5" /> -->
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <!-- ****** only for open bet Artemis Bookmaker ******-->
                        <v-expansion-panels
                            :value="openAllPremium"
                            flat
                            tile
                            multiple
                        >
                            <v-expansion-panel
                                v-for="(
                                    betsData, i
                                ) in betsDatasPremiumBookmaker"
                                :key="'betdata' + i"
                                class="my-3 dropdown"
                            >
                                <v-expansion-panel-header
                                    class="pl-0 pt-0 pb-0 caption align-self-stretch dropdown"
                                >
                                    <v-row no-gutters>
                                        <v-col cols="12" class="pl-2 py-2">
                                            {{ betsData.name }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content dark class="pa-0">
                                    <div
                                        v-if="
                                            betsData.name ===
                                            'Premium Bookmaker'
                                        "
                                    >
                                        <div
                                            v-if="
                                                !matchedBetBookmakerMarket &&
                                                !matchedBetBookmakerMarket
                                            "
                                        >
                                            <no-data-found
                                                icon-custom="mdi mdi-alert"
                                                bet-text="No Premium Bookmaker Bets!"
                                            />
                                        </div>
                                        <matched-bets-premium-bookmaker-raw
                                            v-if="
                                                matchedBetBookmakerMarket &&
                                                matchedBetBookmakerMarket.length
                                            "
                                            :bet-data-matched-premium="
                                                matchedBetBookmakerMarket
                                            "
                                        />
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <!-- ****** only for open bet betby ******-->
                        <v-expansion-panels
                            :value="openAllPremium"
                            flat
                            tile
                            multiple
                        >
                            <v-expansion-panel
                                v-for="(betsData, i) in betsDatasPremium"
                                :key="'betdata' + i"
                                class="my-3"
                            >
                                <v-expansion-panel-header
                                    class="pl-0 pt-0 pb-0 caption align-self-stretch dropdown"
                                >
                                    <v-row no-gutters>
                                        <v-col cols="12" class="pl-2 py-2">
                                            {{ betsData.name }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content dark class="pa-0">
                                    <div
                                        v-if="
                                            betsData.name ===
                                            'Premium SportsBook'
                                        "
                                    >
                                        <div
                                            v-if="
                                                !matchedBetPremiumData &&
                                                !matchedBetPremiumRawData
                                            "
                                        >
                                            <no-data-found
                                                icon-custom="mdi mdi-alert"
                                                bet-text="No Premium SportsBook Bets!"
                                            />
                                        </div>
                                        <matched-bets-premium
                                            v-if="
                                                matchedBetPremiumData &&
                                                matchedBetPremiumData.length
                                            "
                                            :bet-data-matched-premium="
                                                matchedBetPremiumData
                                            "
                                        />
                                        <!-- matched bet premium raw -->
                                        <matched-bets-premium-raw
                                            v-if="matchedBetPremiumRawData"
                                            :bet-data-matched-premium="
                                                matchedBetPremiumRawData
                                            "
                                        />
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-tab-item>
                <!-- my market section -->
                <v-tab-item>
                    <v-container class="pt-2 px-0">
                        <v-skeleton-loader
                            v-if="loading"
                            tile
                            dense
                            type="list-item-two-line, list-item-two-line"
                        >
                        </v-skeleton-loader>
                        <div v-if="isEmpty" class="pa-5">
                            <no-data-found
                                icon-custom="mdi mdi-alert"
                                bet-text="Your markets will be shown here."
                            />
                            <!-- <v-alert dense border="left" outlined type="warning">
            Your markets will be shown here.
          </v-alert> -->
                        </div>
                        <div v-if="!isEmpty">
                            <my-market-data :my-market-data="myMarketMatched" />
                        </div>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex"
// import NoResult from '@/components/NoResult'
// import FavoriteBtn from '@/components/FavoriteBtn'
import MatchedBets from "@/components/MatchedBets"
import NoDataFound from "@/components/NoDataFound"
import ObCard from "@/components/open-bets/ObCard"
import AverageBets from "@/components/open-bets/AverageBets"
import MyMarketData from "@/components/MyMarketData"
import MatchedBetsPremium from "@/components/MatchedBetsPremium"
import MatchedBetsPremiumRaw from "@/components/MatchedBetsPremiumRaw"
import MatchedBetsPremiumBookmakerRaw from "@/components/MatchedBetsPremiumBookmakerRaw"
import socket from "@/plugins/socket.client"

export default {
    components: {
        NoDataFound,
        MatchedBets,
        MyMarketData,
        MatchedBetsPremium,
        MatchedBetsPremiumRaw,
        MatchedBetsPremiumBookmakerRaw,
        ObCard,
        AverageBets
    },
    props: {
        showLive: { type: Boolean, default: false, required: false },
        showScore: { type: Boolean, default: false, required: false },
        tvScorePositionSwitch: {
            type: Boolean,
            default: false,
            required: false
        },
        popoverHeight: { type: Number, default: 0, required: false }
    },
    data() {
        return {
            showAverage: false,
            sortBets: false,
            sortLadderBets: false,
            showLadderAverage: false,
            menu: false,
            tabs: null,
            pageName: this.$route.name,
            panel: [],
            clickedBetId: null,
            initialHeight: 0,
            maxAddHeight: 134,
            scorecardError: false,
            throttleTimeout: null
        }
    },

    computed: {
        ...mapState({
            // open bets variables
            hideMatch: (state) => state.openBets.hideMatch,
            hideUnMatch: (state) => state.openBets.hideUnMatch,
            deleteData: (state) => state.openBets.deleteData,
            loading: (state) => state.openBets.loading,
            betsDatas: (state) => state.openBets.betsDatas,
            betsDatasPremium: (state) => state.openBets.betsDatasPremium,
            betsDatasPremiumBookmaker: (state) =>
                state.openBets.betsDatasPremiumBookmaker,
            unmatched: (state) => state.openBets.unmatched,
            unMatchedbetsLength: (state) => state.openBets.unMatchedbetsLength,
            cancelLoading: (state) => state.openBets.cancelLoading,
            cancelflag: (state) => state.openBets.cancelflag,
            emptyData: (state) => state.openBets.emptyData,
            averageBetsData: (state) => state.openBets.average,
            matchedBetPremiumData: (state) => state.openBets.matchedBetPremium,
            matchedBetPremiumRawData: (state) =>
                state.openBets.matchedBetPremiumRaw,
            matchedBetBookmakerMarket: (state) =>
                state.openBets.matchedBetBookmakerMarket,

            // my market variables
            myMarketMatched: (state) => state.myMarkets.myMarketData,
            isEmpty: (state) => state.myMarkets.isEmpty,
            openAll() {
                const betsCount = [
                    this.betsDatas[0]?.unMatchedbets?.length ?? 0,
                    this.betsDatas[1]?.matchedBets?.length ?? 0,
                    this.betsDatas[2]?.lineLadder?.length ?? 0
                ]
                // eslint-disable-next-line array-callback-return
                const panelOpen = betsCount.map((d, i) => {
                    if (d > 0) {
                        return i
                    }
                })
                return [...panelOpen]
            },
            openAllPremium() {
                let count
                if (
                    this.matchedBetPremiumData &&
                    this.matchedBetPremiumData.length
                ) {
                    count = this.matchedBetPremiumData.length
                } else if (
                    this.matchedBetPremiumRawData &&
                    this.matchedBetPremiumRawData.length
                ) {
                    count = this.matchedBetPremiumRawData.length
                } else if (
                    this.matchedBetBookmakerMarket &&
                    this.matchedBetBookmakerMarket.length
                ) {
                    count = this.matchedBetBookmakerMarket.length
                } else {
                    count = null
                }
                const betsCount = [count]
                // eslint-disable-next-line array-callback-return
                const panelOpen = betsCount.map((d, i) => {
                    if (d > 0) {
                        return i
                    }
                })
                return [...panelOpen]
            }
        }),
        dynamicHeight() {
            if (
                this.$route.name === "bets" ||
                this.$vuetify.breakpoint.smAndDown
            )
                return {}
            const offset = this.calcOffsetHeight()
            return {
                height: `calc(100vh - ${offset}px)`
            }
        },
        pageTitleHeight() {
            return this.$route.name ===
                "sportsbook-category-subCategory-id-betradar"
                ? 48
                : 0
        }
    },
    watch: {
        dynamicHeight() {
            this.updateHeight()
        },
        scorecardError() {
            this.updateHeight()
        }
    },

    async mounted() {
        this.initialHeight = this.$refs.mybetssection.offsetHeight
        window.addEventListener("scroll", this.handleScroll)
        this.runOnSrErrorContainerMounted((isScoreCardError) => {
            console.log("Scorecard error!")
            this.scorecardError = isScoreCardError
        })

        if (!this.$route.params.id) {
            this.$store.commit("openBets/empty_data")
        }
        await this.initiate(true)
        socket.commonSocket.on(
            "BetSocket_" + this.$auth.user._id,
            async (eventKeys) => {
                if (
                    eventKeys.eventKey ===
                        "BetExecuted_" + this.$auth.user._id ||
                    eventKeys.eventKey ===
                        "premium_bet_executed_" + this.$auth.user._id
                ) {
                    const betDataUnmatchBets = this.betsDatas[0].unMatchedbets
                    for (let i = 0; i < betDataUnmatchBets.length; i++) {
                        if (betDataUnmatchBets[i].betId === eventKeys._id) {
                            betDataUnmatchBets[i].remove = true
                        }
                    }
                    await this.initiate(false)
                }
            }
        )
    },

    beforeDestroy() {
        if (!this.$route.params.id) {
            this.$store.commit("openBets/empty_data")
        }
        window.removeEventListener("scroll", this.handleScroll)
    },
    methods: {
        opendata() {},
        openMyMarket() {
            this.$store.dispatch("myMarkets/getMarkets")
        },
        initiate(bool) {
            this.$store.dispatch("openBets/getMyCurrentBetStatus", bool)
            this.$store.dispatch("openBets/getMyCurrentPremiumBet", bool)
            this.$store.dispatch("openBets/getMyCurrentPremiumRawBet", bool)
            this.$store.dispatch(
                "openBets/getMyCurrentBetStatusBookmakerMarket",
                bool
            )
        },
        checkunMatchBets() {
            // eslint-disable-next-line array-callback-return
            const output = this.betsDatas.filter((b) => {
                if (b.unMatchedbets && b.unMatchedbets.length) {
                    return b
                }
            })
            return !output.length
        },

        checkunMatchBetsClass() {
            if (
                this.betsDatas &&
                this.betsDatas[0]?.unMatchedbets?.length &&
                this.betsDatas[1]?.matchedBets?.length
            ) {
                return {
                    "overflow-minor-scroll": true,
                    "overflow-scroll": false
                }
            } else if (this.betsDatas[0]?.unMatchedbets.length) {
                return {
                    "overflow-minor-scroll": false,
                    "overflow-scroll": true
                }
            } else {
                return {
                    "overflow-minor-scroll": false,
                    "overflow-scroll": false
                }
            }
        },
        checkMatchBetsClass() {
            if (
                this.betsDatas[0].unMatchedbets.length &&
                this.betsDatas[1].matchedBets.length
            ) {
                return {
                    "overflow-minor-scroll": true,
                    "overflow-scroll": false
                }
            } else if (this.betsDatas[1].matchedBets.length) {
                return {
                    "overflow-minor-scroll": false,
                    "overflow-scroll": true
                }
            } else {
                return {
                    "overflow-minor-scroll": false,
                    "overflow-scroll": false
                }
            }
        },
        cancelPerMatch(unmatchedBetData) {
            const betArray = []
            if (unmatchedBetData.bets.length) {
                for (const bet of unmatchedBetData.bets) {
                    const obj = {}
                    obj.betId = bet.betId
                    obj.betType = bet.betType
                    betArray.push(obj)
                    // this.cancelBet(bet, '', 'All Bets Cancelled')
                }
                this.cancelMultipleBets(betArray)
            }
        },

        cancelAllBets() {
            const allunmatchedBets = []
            if (this.unmatched.length) {
                this.unmatched.forEach((bets) => {
                    bets.markets.forEach((market) => {
                        market.runners.forEach((runners) => {
                            allunmatchedBets.push(...runners.bets)
                        })
                    })
                })

                const betArray = []
                for (const bet of allunmatchedBets) {
                    if (bet.betType !== "threeEt") {
                        const obj = {}
                        obj.betId = bet.betId
                        obj.betType = bet.betType
                        betArray.push(obj)
                    } else {
                        this.$store.commit("snackbar/open", {
                            text: "Cant cancel the premium bet, bet is in process",
                            color: "error"
                        })
                    }
                }
                if (betArray.length > 0) {
                    this.cancelMultipleBets(betArray)
                }
            }
        },
        async cancelMultipleBets(betArray) {
            const accessTokenId = this.$auth.getToken("customLocal")
            const payloadData = {
                accessToken: accessTokenId,
                betArray
            }
            await this.$store.dispatch(
                "openBets/cancelPlayerBetPerMatch",
                payloadData
            )
            const betMsgs = []
            if (this.deleteData && this.deleteData.value) {
                const { lineCancel, mainCancel } = this.deleteData.data

                const allBets = [...lineCancel, ...mainCancel]

                allBets.forEach((bet) => {
                    if (bet && bet.message) {
                        betMsgs.push(bet.message)
                    } else {
                        betMsgs.push("Error while cancelling Bet")
                    }
                })

                const isSuccess = allBets.every((bet) => bet.value)

                this.$store.commit("snackbar/openMultiple", {
                    texts: betMsgs,

                    color: isSuccess ? "success" : "error"
                })
            } else if (
                this.deleteData &&
                this.deleteData.error === "accessDenied"
            ) {
                this.$store.commit("snackbar/open", {
                    text: "Access Denied",
                    color: "error"
                })
            } else {
                this.$store.commit("snackbar/open", {
                    text: "Error while cancelling Bet",
                    color: "error"
                })
            }
        },
        async cancelBet(betArray, level, successText = "Bet Cancelled") {
            const betidData = betArray.betId
            this.clickedBetId = betidData
            const betTypeData = betArray.betType
            const accessTokenId = this.$auth.getToken("customLocal")
            const payloadData = {
                accessToken: accessTokenId,
                betId: betidData,
                betType: betTypeData
            }
            await this.$store.dispatch("openBets/cancelPlayerBet", payloadData)

            if (this.deleteData?.value) {
                const { lineCancel, mainCancel } = this.deleteData.data
                ;[...lineCancel, ...mainCancel].forEach((bet) => {
                    if (bet && bet.message) {
                        this.$store.commit("snackbar/open", {
                            text: bet.message,
                            color: bet.value ? "success" : "error"
                        })
                    } else {
                        this.$store.commit("snackbar/open", {
                            text: "Error while cancelling Bet",
                            color: "error"
                        })
                    }
                })
            } else if (this.deleteData?.error === "accessDenied") {
                this.$store.commit("snackbar/open", {
                    text: "Access Denied",
                    color: "error"
                })
            } else {
                this.$store.commit("snackbar/open", {
                    text: "Error while cancelling Bet",
                    color: "error"
                })
            }
            this.clickedBetId = null
        },
        calcOffsetHeight() {
            let offsetHeight
            if (this.showScore && window?.SIR && !this.tvScorePositionSwitch) {
                offsetHeight = this.scorecardError ? 308 : 382
            } else if (this.showLive && this.tvScorePositionSwitch) {
                offsetHeight = 284
            } else {
                offsetHeight = this.maxAddHeight
            }
            return offsetHeight + this.popoverHeight + this.pageTitleHeight
        },
        handleScroll() {
            if (
                this.$route.name === "bets" ||
                this.$vuetify.breakpoint.smAndDown
            ) {
                return
            }

            if (!this.throttleTimeout) {
                this.throttleTimeout = setTimeout(() => {
                    const offset = this.calcOffsetHeight()
                    const scrollY = window.scrollY
                    const addedHeight = Math.min(scrollY, this.maxAddHeight)
                    this.$refs.mybetssection.style.height = `calc(100vh - ${
                        offset - addedHeight
                    }px)`
                    this.throttleTimeout = null
                }, 250)
            }
        },
        runOnSrErrorContainerMounted(callback) {
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        const targetElement = document.querySelector(
                            ".sr-error__container"
                        )
                        if (targetElement) {
                            // eslint-disable-next-line node/no-callback-literal
                            callback(true)
                            observer.disconnect() // Stop observing once the element is found
                            return
                        } else {
                            // eslint-disable-next-line node/no-callback-literal
                            callback(false)
                        }
                    }
                }
            })

            observer.observe(document.body, { childList: true, subtree: true })

            // Added a timeout in case the element never appears
            setTimeout(() => {
                if (!document.querySelector(".sr-error__container")) {
                    console.log(
                        "sr-error__container element not found within the timeout."
                    )
                    observer.disconnect()
                }
            }, 10000)
        },
        updateHeight() {
            setTimeout(() => {
                this.initialHeight = this.$refs.mybetssection.offsetHeight
                this.handleScroll()
            }, 100)
        }
    }
}
</script>
<style lang="scss">
$primary: var(--v-primary-base);
.mybetssection {
    // background: #1e1e1e;
    // border-bottom-left-radius: 1rem;
    // border-bottom-right-radius: 1rem;
    // max-height: 620px;
    overflow-x: hidden;
    overflow-y: auto;
    &.white-theme {
        .matched-bets {
            .v-icon {
                color: $primary !important;
            }
        }
        .align-self-center.v-btn {
            .v-icon.mdi-star-outline,
            .v-icon.mdi-star {
                color: #ffc107 !important;
            }
        }
        .v-expansion-panel-header__icon {
            .v-icon {
                color: #fff !important;
            }
        }
    }
    &.dark-theme {
        .align-self-center.v-btn {
            .v-icon.mdi-star-outline,
            .v-icon.mdi-star {
                color: #ffc107 !important;
            }
        }
    }
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 0.2rem !important;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 8px !important;
        color: #000 !important;
        &.caption {
            color: #333;
            padding: 0 0.2rem !important;
            .v-input__slot {
                margin: 0;
                font-size: 0.6px;
            }
            div {
                font-size: 0.6rem;
            }
            button {
                &.red--text {
                    span {
                        font-size: 0.6rem;
                        justify-content: flex-start;
                    }
                }
            }
        }
    }
    .my-bet-border {
        border-radius: 1rem;
    }
    .top-btm-space {
        margin-top: 6px;
        // margin-bottom: 16px;
    }
    &.dark-theme {
        .v-icon.mdi-alert {
            color: $primary !important;
        }
    }
    .expand-transition-enter-active,
    .expand-transition-leave-active {
        transition: none !important;
    }
}
@media screen and (min-width: 960px) {
    .matched-bets-checkbox label {
        font-size: 10px !important;
    }
}
</style>
